import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import LoadingSkeleton from 'marketing-platform-lib/components/LoadingSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CardPreviewSkeleton() {
  return /*#__PURE__*/_jsxs(CardWrapper, {
    compact: true,
    "data-test-id": "card-preview-skeleton",
    children: [/*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "28px",
        inlineSize: "230px"
      })
    }), /*#__PURE__*/_jsxs(CardSection, {
      children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "20px",
        inlineSize: "150px",
        marginBlockEnd: "100"
      }), /*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "20px",
        inlineSize: "180px",
        marginBlockEnd: "100"
      }), /*#__PURE__*/_jsx(LoadingSkeleton, {
        blockSize: "20px",
        inlineSize: "120px",
        marginBlockEnd: "100"
      })]
    })]
  });
}